import { useState, useEffect } from "react";
import { fetchPrograms } from "../../redux/program/programActions";
import { FaGraduationCap } from "react-icons/fa";
import { PDFDocument } from "pdf-lib";
import { termOptions } from "../../utils/helper";
import Loader from "../../components/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
import { getClassWiseStudentList } from "../../services/StudentService";
import {
  downloadReportCard,
  downloadExcelReport,
} from "../../services/ReportCardService";
import Select from "../../components/Select/Select";
import Button from "../../components/Button/Button";
import Switch from "../../components/Switch/Switch";
import Modal from "../../components/Modal/Modal";
import { Alert } from "react-bootstrap";
import Table from "../../components/Table/Table";
import { reportCardTableConstants } from "./ReportCardTableConstant";
import "./ReportCard.css";

function ReportCardManage() {
  const [studentList, setStudentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [term, setTerm] = useState("");
  const [program_id, setProgramId] = useState("");
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [resultSuccessData, setResultSuccessData] = useState([]);
  const [resultFailedData, setResultFailedData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isSendS3, setIsSendS3] = useState(0);
  const [permissions] = useState(
    JSON.parse(localStorage.getItem("permissions")) || [],
  );
  const dispatch = useDispatch();
  const programData = useSelector((state) => state.program.programs.data);

  const getStudentList = async (program_id) => {
    setLoading(true);

    try {
      const response = await getClassWiseStudentList(program_id);
      if (response.status === 200) {
        const studentList = response.data.data;
        setStudentList(studentList);
        setSelectedStudentIds(
          studentList.map((student) => student.id.toString()),
        );
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(fetchPrograms());
  }, [dispatch]);

  const fetchReportCardPdf = async (
    studentId,
    termValue,
    sendToS3 = isSendS3,
  ) => {
    const sessionId = localStorage.getItem("session_id");

    return downloadReportCard(studentId, sessionId, termValue, sendToS3, {
      responseType: "arraybuffer",
    });
  };

  const hasPdfSignature = (bytes) => {
    if (!bytes || bytes.length < 5) {
      return false;
    }

    const scanLimit = Math.min(bytes.length - 4, 1024);
    for (let i = 0; i <= scanLimit; i += 1) {
      if (
        bytes[i] === 0x25 &&
        bytes[i + 1] === 0x50 &&
        bytes[i + 2] === 0x44 &&
        bytes[i + 3] === 0x46 &&
        bytes[i + 4] === 0x2d
      ) {
        return true;
      }
    }

    return false;
  };

  const extractPdfBytesFromResponse = (response) => {
    const rawData = response?.data;
    let bytes;

    if (rawData instanceof ArrayBuffer) {
      bytes = new Uint8Array(rawData);
    } else if (rawData instanceof Uint8Array) {
      bytes = rawData;
    } else if (rawData?.buffer instanceof ArrayBuffer) {
      bytes = new Uint8Array(rawData.buffer);
    } else {
      throw new Error("Invalid response payload for PDF");
    }

    const contentType =
      response?.headers?.["content-type"] ||
      response?.headers?.["Content-Type"] ||
      "";

    const hasPdfHeader = hasPdfSignature(bytes);

    if (!contentType.toLowerCase().includes("pdf") && !hasPdfHeader) {
      throw new Error(
        `Response is not a PDF. Content-Type: ${contentType || "unknown"}`,
      );
    }

    if (!hasPdfHeader) {
      throw new Error(
        "Response does not contain a valid PDF signature (%PDF-)",
      );
    }

    return bytes;
  };

  const downloadPdfBlob = (pdfData, fileName) => {
    const pdfUrl = window.URL.createObjectURL(
      new Blob([pdfData], { type: "application/pdf" }),
    );
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    setTimeout(() => {
      window.URL.revokeObjectURL(pdfUrl);
    }, 30000);
  };

  const changeHandler = async (e) => {
    const value = e.target.value;
    if (e.target.name === "program_id") {
      setProgramId(value);
      getStudentList(value);
      setSelectedStudentIds([]);
    }
    if (e.target.name === "term") {
      setTerm(value);
    }
  };
  //...Other imports and component code ...
  useEffect(() => {}, [resultSuccessData, resultFailedData]);

  // const downloadAllResult = async (studentList, term) => {
  //   if (selectedStudentIds.length === 0) {
  //     enqueueSnackbar(
  //       "Please select atleast one student to download the result",
  //       { variant: "error" },
  //     );
  //     return;
  //   }

  //   setResultSuccessData([]);
  //   setResultFailedData([]);
  //   let mergerSuccess = [];
  //   let failedResponse = [];
  //   let encryptedDownloadedCount = 0;
  //   const selectedProgram = programData.find(
  //     (program) => program.id === parseInt(program_id, 10),
  //   );
  //   const cls = selectedProgram?.name || "Class";
  //   const mergedPdf = await PDFDocument.create();
  //   enqueueSnackbar(
  //     "Please wait, it will take time to download the complete results",
  //     { variant: "info" },
  //   );

  //   const finalStudentList = studentList.filter((student) =>
  //     selectedStudentIds.includes(student.id.toString()),
  //   );

  //   for (const student of finalStudentList) {
  //     const student_id = student.id;
  //     const name = student.first_name;

  //     try {
  //       const response = await fetchReportCardPdf(student_id, term);

  //       if (response.status === 200) {
  //         const pdfBytes = extractPdfBytesFromResponse(response);
  //         let pdfDoc;

  //         try {
  //           pdfDoc = await PDFDocument.load(pdfBytes);
  //         } catch (loadError) {
  //           const isEncryptedPdf =
  //             loadError?.message &&
  //             loadError.message.toLowerCase().includes("encrypted");

  //           if (!isEncryptedPdf) {
  //             throw loadError;
  //           }

  //           // Encrypted PDFs can become blank after browser-side merge.
  //           // Download them individually and skip from merged output.
  //           const encryptedBlobUrl = window.URL.createObjectURL(
  //             new Blob([response.data], { type: "application/pdf" }),
  //           );
  //           const encryptedLink = document.createElement("a");
  //           encryptedLink.href = encryptedBlobUrl;
  //           encryptedLink.setAttribute(
  //             "download",
  //             `${name}-${student.id_number || student.id}-term-${term}.pdf`,
  //           );
  //           document.body.appendChild(encryptedLink);
  //           encryptedLink.click();
  //           encryptedLink.remove();
  //           setTimeout(() => {
  //             window.URL.revokeObjectURL(encryptedBlobUrl);
  //           }, 30000);

  //           encryptedDownloadedCount += 1;
  //           failedResponse.push({
  //             student_id: student_id,
  //             name: name,
  //             roll_no: student.roll_no,
  //             error: "Encrypted PDF downloaded separately (not added to merged file)",
  //           });
  //           setResultFailedData([...failedResponse]);
  //           enqueueSnackbar(
  //             `${name}: encrypted PDF downloaded separately`,
  //             { variant: "warning" },
  //           );
  //           continue;
  //         }

  //         const pages = await mergedPdf.copyPages(
  //           pdfDoc,
  //           pdfDoc.getPageIndices(),
  //         );
  //         pages.forEach((page) => mergedPdf.addPage(page));
  //         enqueueSnackbar(
  //           "Result of " +
  //             name +
  //             ` and rollno. ${student.roll_no} downloaded successfully`,
  //           { variant: "success" },
  //         );
  //         mergerSuccess.push({
  //           student_id: student_id,
  //           name: name,
  //           roll_no: student.roll_no,
  //         });
  //         setResultSuccessData([...mergerSuccess]);
  //       }
  //     } catch (error) {
  //       const isEncryptedError =
  //         error?.message &&
  //         error.message.toLowerCase().includes("encrypted");

  //       failedResponse.push({
  //         student_id: student_id,
  //         name: name,
  //         roll_no: student.roll_no,
  //         error: isEncryptedError
  //           ? "Encrypted PDF cannot be merged in browser"
  //           : error?.message || "Unable to process PDF response",
  //       });
  //       setResultFailedData([...failedResponse]);
  //       enqueueSnackbar(
  //         isEncryptedError
  //           ? `${name} failed: encrypted PDF (merge supported only from backend)`
  //           : `${name} failed: ${error?.message || "Invalid PDF"}`,
  //         {
  //           variant: "error",
  //         },
  //       );
  //       console.error("Error downloading PDF:", error);
  //     }
  //   }

  //   if (mergerSuccess.length === 0) {
  //     enqueueSnackbar(
  //       encryptedDownloadedCount > 0
  //         ? "Merged PDF not generated: encrypted report cards were downloaded separately"
  //         : "No report card was available to merge",
  //       {
  //         variant: encryptedDownloadedCount > 0 ? "warning" : "error",
  //       },
  //     );
  //     setIsOpen(true);
  //     return;
  //   }

  //   try {
  //     const mergedPdfBytes = await mergedPdf.save({ useObjectStreams: false });

  //     // Trigger a single merged file download after all pages are appended.
  //     const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
  //     const link = document.createElement("a");
  //     const url = window.URL.createObjectURL(blob);
  //     link.href = url;
  //     link.setAttribute(
  //       "download",
  //       `Merged-ReportCards-Class-${cls}-Term-${term}.pdf`,
  //     );
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();

  //     // Keep URL alive for this event loop so slower browsers can start download.
  //     setTimeout(() => {
  //       window.URL.revokeObjectURL(url);
  //     }, 30000);

  //     enqueueSnackbar("Merged report card downloaded successfully", {
  //       variant: "success",
  //     });

  //     if (encryptedDownloadedCount > 0) {
  //       enqueueSnackbar(
  //         `${encryptedDownloadedCount} encrypted report card(s) were downloaded separately`,
  //         { variant: "warning" },
  //       );
  //     }
  //     setIsOpen(true);
  //   } catch (mergeError) {
  //     console.error("Error while generating merged PDF:", mergeError);
  //     enqueueSnackbar("Failed to merge class report cards", {
  //       variant: "error",
  //     });
  //   }
  // };

  const downloadAllResult = async (studentList, term) => {
    if (selectedStudentIds.length === 0) {
      enqueueSnackbar(
        "Please select atleast one student to download the result",
        { variant: "error" },
      );
      return;
    }

    setResultSuccessData([]);
    setResultFailedData([]);

    let mergerSuccess = [];
    let failedResponse = [];
    let encryptedDownloadedCount = 0;

    const selectedProgram = programData.find(
      (program) => program.id === parseInt(program_id, 10),
    );

    const cls = selectedProgram?.name || "Class";

    const mergedPdf = await PDFDocument.create();

    enqueueSnackbar(
      "Please wait, it will take time to download the complete results",
      { variant: "info" },
    );

    const finalStudentList = studentList.filter((student) =>
      selectedStudentIds.includes(student.id.toString()),
    );

    for (const student of finalStudentList) {
      const student_id = student.id;
      const name = student.first_name;

      try {
        const response = await fetchReportCardPdf(student_id, term);

        if (response.status === 200) {
          const pdfBytes = extractPdfBytesFromResponse(response);

          let embeddedPages;

          try {
            // embedPdf defaults to page [0] only; pass all page indices
            const sourcePdf = await PDFDocument.load(pdfBytes);
            embeddedPages = await mergedPdf.embedPdf(
              sourcePdf,
              sourcePdf.getPageIndices(),
            );
          } catch (embedError) {
            const isEncryptedPdf =
              embedError?.message &&
              embedError.message.toLowerCase().includes("encrypted");

            if (!isEncryptedPdf) {
              throw embedError;
            }

            encryptedDownloadedCount += 1;
            failedResponse.push({
              student_id: student_id,
              name: name,
              roll_no: student.roll_no,
              error: "Encrypted PDF downloaded separately (not added to merged file)",
            });
            setResultFailedData([...failedResponse]);

            downloadPdfBlob(
              response.data,
              `${name}-${student.id_number || student.id}-term-${term}.pdf`,
            );

            enqueueSnackbar(`${name}: encrypted PDF downloaded separately`, {
              variant: "warning",
            });
            continue;
          }

          embeddedPages.forEach((embeddedPage) => {
            const page = mergedPdf.addPage([
              embeddedPage.width,
              embeddedPage.height,
            ]);

            page.drawPage(embeddedPage);
          });

          mergerSuccess.push({
            student_id: student_id,
            name: name,
            roll_no: student.roll_no,
          });
          setResultSuccessData([...mergerSuccess]);

          enqueueSnackbar(
            `Result of ${name} (Roll No: ${student.roll_no}) merged successfully`,
            { variant: "success" },
          );
        }
      } catch (error) {
        console.error("Error downloading PDF:", error);

        failedResponse.push({
          student_id: student_id,
          name: name,
          roll_no: student.roll_no,
          error: error?.message || "Invalid PDF",
        });
        setResultFailedData([...failedResponse]);

        enqueueSnackbar(`${name} failed: ${error?.message || "Invalid PDF"}`, {
          variant: "error",
        });
      }
    }

    if (mergerSuccess.length === 0) {
      enqueueSnackbar(
        encryptedDownloadedCount > 0
          ? "Merged PDF not generated: encrypted report cards were downloaded separately"
          : "No report card was available to merge",
        {
          variant: encryptedDownloadedCount > 0 ? "warning" : "error",
        },
      );
      setIsOpen(true);
      return;
    }

    try {
      // 🔥 SAFE SAVE OPTIONS
      const mergedPdfBytes = await mergedPdf.save({
        useObjectStreams: false,
        addDefaultPage: false,
        updateMetadata: false,
      });

      const blob = new Blob([mergedPdfBytes], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Merged-ReportCards-Class-${cls}-Term-${term}.pdf`,
      );

      document.body.appendChild(link);
      link.click();
      link.remove();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 30000);

      enqueueSnackbar("Merged report card downloaded successfully", {
        variant: "success",
      });

      if (encryptedDownloadedCount > 0) {
        enqueueSnackbar(
          `${encryptedDownloadedCount} encrypted report card(s) were downloaded separately`,
          { variant: "warning" },
        );
      }

      setIsOpen(true);
    } catch (mergeError) {
      console.error("Error while generating merged PDF:", mergeError);

      enqueueSnackbar("Failed to merge class report cards", {
        variant: "error",
      });
    }
  };

  const downloadExcelResult = async () => {
    try {
      const cls = programData.find(
        (program) => program.id === parseInt(program_id),
      ).name;
      const session_id = localStorage.getItem("session_id");
      setLoading(true);
      const response = await downloadExcelReport(program_id, session_id, term, {
        responseType: "arraybuffer",
      });
      const arrayBuffer = response.data;
      // Create a blob from the array buffer
      const blob = new Blob([arrayBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      // Create a download link and trigger the download
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${cls}-term-${term}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      enqueueSnackbar("Internal Server Error!", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const previewResult = async (student, termValue) => {
    let student_id = student.id;

    try {
      enqueueSnackbar(
        "Please wait, it will take time to download the complete results",
        { variant: "info" },
      );
      const response = await fetchReportCardPdf(student_id, termValue, 1);
      if (response.status === 200) {
        enqueueSnackbar("Result downloaded successfully", {
          variant: "success",
        });
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        // Open the PDF in a new tab
        window.open(url, "_blank");
      }
    } catch (error) {
      enqueueSnackbar("Exam Marking Not Yet Completed!", { variant: "error" });
      console.error(error);
    }
  };

  const downloadResult = async (student, termValue) => {
    let student_id = student.id;
    let name = student.first_name;
    let id_number = student.id_number;
    try {
      enqueueSnackbar(
        "Please wait, it will take time to download the complete results",
        { variant: "info" },
      );
      const response = await fetchReportCardPdf(student_id, termValue);
      if (response.status === 200) {
        enqueueSnackbar("Result downloaded successfully", {
          variant: "success",
        });
        const blob = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blob;
        link.setAttribute(
          "download",
          `${name}-${id_number}-term-${termValue}.pdf`,
        );
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      enqueueSnackbar("Exam Marking Not Yet Completed!", { variant: "error" });
      console.error(error);
    }
  };

  const selectStudentHandler = (e) => {
    if (e.target.value === "all") {
      if (e.target.checked) {
        setSelectedStudentIds(
          studentList.map((student) => student.id.toString()),
        );
      } else {
        setSelectedStudentIds([]);
      }
    } else {
      if (e.target.checked) {
        setSelectedStudentIds([
          ...selectedStudentIds,
          e.target.value.toString(),
        ]);
      } else {
        setSelectedStudentIds(
          selectedStudentIds.filter((id) => id !== e.target.value),
        );
      }
    }
  };

  return (
    <div className="program-list">
      <div className="animated">
        <div className="card">
          <div className="card-header">
            <div className="d-flex justify-content-between align-items-center">
              <div className="main-title-page page-title d-flex align-items-center">
                <div className="mx-2">
                  <FaGraduationCap />
                </div>
                <span>Report Card List</span>
              </div>
            </div>
          </div>
          <div className="row card-body">
            <div className="col-md-6">
              <Select
                label="Term"
                name="term"
                placeholder={"Select Term"}
                value={term}
                onChangeHandler={changeHandler}
                options={termOptions}
              />
            </div>
            <div className="col-md-6">
              <Select
                label="Class"
                name="program_id"
                placeholder={"Select Class"}
                value={program_id}
                onChangeHandler={changeHandler}
                options={programData}
              />
            </div>
            {permissions.includes("report.card.send.to.s3") && (
              <div className="col-md-6 mt-3">
                <div className="rc-s3-panel">
                  <label className="rc-s3-label">Send to S3:</label>
                  <Switch
                    name="send_s3"
                    id="send_s3_toggle"
                    checked={isSendS3 === 1}
                    onChange={() => setIsSendS3(isSendS3 === 1 ? 0 : 1)}
                    title={
                      isSendS3 === 1 ? "Will send to S3" : "Will not send to S3"
                    }
                  />
                  <span className="rc-s3-status">
                    {isSendS3 === 1 ? "✓ Yes" : "✗ No"}
                  </span>
                </div>
              </div>
            )}
            <Modal
              isOpen={isOpen}
              title="Failed to download report card"
              onClose={() => setIsOpen(false)}
            >
              <div>
                {resultFailedData && resultFailedData.length > 0 && (
                  <Alert
                    variant="danger"
                    style={{ color: "var(--color-danger-text)" }}
                    className="mt-4"
                  >
                    <h5>
                      Failed to download report card for the following students:
                    </h5>
                    <ol>
                      {resultFailedData.length > 0 &&
                        resultFailedData.map((data, index) => (
                          <li key={index} className="p-1">
                            {data.name} (Roll No: {data.roll_no})
                          </li>
                        ))}
                    </ol>
                  </Alert>
                )}
                {resultSuccessData.length > 0 && (
                  <Alert
                    variant="success"
                    className="mt-4"
                    style={{ color: "var(--color-success-text)" }}
                  >
                    <h5>
                      You are downloaded the report card for the following
                      students:
                    </h5>
                    <ol>
                      {resultSuccessData &&
                        resultSuccessData.map((student, index) => (
                          <li key={index} className="p-1">
                            {student.name} - RollNo.{student.roll_no}
                          </li>
                        ))}
                    </ol>
                  </Alert>
                )}
              </div>
              <Button onClick={() => setIsOpen(false)}>Close</Button>
            </Modal>
          </div>
          {loading ? (
            <Loader />
          ) : (
            <div className="card-body evaluating-table">
              <Table
                cols={reportCardTableConstants(
                  selectStudentHandler,
                  selectedStudentIds,
                  previewResult,
                  downloadResult,
                  term,
                  studentList,
                  downloadAllResult,
                  downloadExcelResult,
                )}
                data={studentList}
                bordered={true}
                hoverable={true}
                striped={true}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default ReportCardManage;
